import React from "react";
import { Paperclip } from "lucide-react";
import { Message } from "../../../types/support.types";

interface AttachmentDisplayProps {
  message: Message;
}

const AttachmentDisplay: React.FC<AttachmentDisplayProps> = ({ message }) => {
  if (!message.image) return null;

  const isImage = message.imageType?.startsWith("image/");
  const imageUrl = `data:${message.imageType};base64,${message.image}`;

  return (
    <div className="mt-2">
      {isImage ? (
        <img
          src={imageUrl}
          alt="Attachment"
          className="max-w-[200px] sm:max-w-xs rounded-lg cursor-pointer hover:opacity-90"
          onClick={() => window.open(imageUrl, "_blank")}
        />
      ) : (
        <a
          href={imageUrl}
          download
          className="flex items-center space-x-2 bg-gray-100 rounded-lg p-3 hover:bg-gray-200 transition-colors max-w-xs"
        >
          <Paperclip size={16} className="text-black" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium truncate text-black">
              Attachment
            </p>
          </div>
        </a>
      )}
    </div>
  );
};

export default AttachmentDisplay;
